import { Collapse, Space } from "antd";
import React from "react";
import { Logo } from "../Logo/Logo";

// Collapse menu for mobile
export const MobileMenu = (props) => {
  const {
    megacta,
    tnavfirst,
    tnavsecond,
    tnavthird,
    bnavfirst,
    bnavsecond,
    bnavthird,
    rightmenu,
    datalinks,
    mcontact,
  } = props;
  const { Panel } = Collapse;

  const openCookieSettings = () => {
    document.querySelector(".cboverlay")?.classList.toggle("visible");
  };

  return (
    <div className="megamenu__wrapper">
      <div className="megamenu__container">
        {megacta && (
          <ul class="megamenu__top menu">
            {megacta.map((item) => (
              <li>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        )}

        <Collapse expandIconPosition="right" ghost>
          {tnavfirst && (
            <Panel header={tnavfirst[0].title} key="1">
              <ul>
                {tnavfirst.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </Panel>
          )}
          {tnavsecond && (
            <Panel header={tnavsecond[0].title} key="2">
              <ul>
                {tnavsecond.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </Panel>
          )}
          {tnavthird && (
            <Panel header={tnavthird[0].title} key="3">
              <ul>
                {tnavthird.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </Panel>
          )}
          {bnavfirst && (
            <Panel header={bnavfirst[0].title} key="4">
              <ul>
                {bnavfirst.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </Panel>
          )}

          {bnavsecond && (
            <Panel header={bnavsecond[0].title} key="5">
              <ul>
                {bnavsecond.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </Panel>
          )}

          {bnavthird && (
            <Panel header={bnavthird[0].title} key="6">
              <ul>
                {bnavthird.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </Panel>
          )}
        </Collapse>
        <div className="megamenu__right">
          {rightmenu && (
            <ul>
              <Space size="small" direction="vertical">
                {rightmenu.map((item) => (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </Space>
            </ul>
          )}
        </div>

        <Space size="large" direction="vertical">
          <Logo />
          <div className="megamenu__contact">
            <div dangerouslySetInnerHTML={{ __html: mcontact }}></div>
          </div>
        </Space>

        <div className="megamenu__footer">
          {datalinks && (
            <ul>
              <Space size="small" direction="vertical">
                {datalinks.map((item, index, array) =>
                  index === array.length - 1 ? (
                    <li>
                      <a onClick={openCookieSettings} href="#">
                        {item.title}
                      </a>
                    </li>
                  ) : (
                    <li>
                      <a href={item.url}>{item.title}</a>
                    </li>
                  ),
                )}
              </Space>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
